import CryptoGPTView from "./CryptoGPTView";

export default CryptoGPTView;
